import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { messages } from './messages';
import styles from './styles.module.less';

export const RateWarningTooltip = () => {
  return (
    <Tooltip>
      <div className={styles.tooltip}>
        <FontAwesomeIcon className={styles['tooltip-icon']} icon={faQuestionCircle} />
      </div>
      <TooltipContent>
        <div>
          <FontAwesomeIcon className={styles['message-icon']} icon={faExclamationTriangle} />
          <FormattedMessage {...messages.carrierDoesNotProvideRate} />
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
